module.exports = __webpack_public_path__ + "img/icon13.dad28971.png";